import Upsertable from '@/models/Upsertable'
import { useTrainingCourseStore } from '@/stores/trainingCourseStore'
import TrainingSchedule from './TrainingSchedule'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class TrainingCourse extends Upsertable {
  static store() {
    return useTrainingCourseStore()
  }

  store() {
    return TrainingCourse.store()
  }

  static all() {
    return TrainingCourse.store().getAll
  }

  static find(uuid) {
    const obj = TrainingCourse.store().find(uuid)
    let training_course = new TrainingCourse()
    return Object.assign(training_course, obj)
  }

  training_schedule() {
    let training_schedule = TrainingSchedule.store().findByTrainingCourseUuid(this.uuid)
    training_schedule.location ??= {}
    return Object.assign(new TrainingSchedule(), training_schedule)
  }
}

useModelName(TrainingCourse, "TrainingCourse")
ModelRegistry.register(TrainingCourse, "TrainingCourse")